export const SET_CAMPAIGNS = 'adsStudio/SET_CAMPAIGNS';
export const SET_LOADING = 'adsStudio/SET_LOADING';
export const SET_SAVING = 'adsStudio/SET_SAVING';
export const SET_GENERATING_COPY = 'adsStudio/SET_GENERATING_COPY';
export const SET_COPY_VARIANTS = 'adsStudio/SET_COPY_VARIANTS';
export const SET_GENERATION_ID = 'adsStudio/SET_GENERATION_ID';
export const SET_ERROR = 'adsStudio/SET_ERROR';
export const ADD_CAMPAIGN = 'adsStudio/ADD_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'adsStudio/UPDATE_CAMPAIGN';
export const REMOVE_CAMPAIGN = 'adsStudio/REMOVE_CAMPAIGN';
